import { render, staticRenderFns } from "./BindingManager.vue?vue&type=template&id=68796ba7&scoped=true"
import script from "./BindingManager.vue?vue&type=script&lang=js"
export * from "./BindingManager.vue?vue&type=script&lang=js"
import style0 from "./BindingManager.vue?vue&type=style&index=0&id=68796ba7&prod&lang=scss&scoped=true"
import style1 from "./BindingManager.vue?vue&type=style&index=1&id=68796ba7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68796ba7",
  null
  
)

export default component.exports